import type { ComponentProps } from 'react';
import { Dropdown, Popconfirm } from '@robinpowered/ui-kit';
import {
  SHELL_OVERLAY_POPUP_Z_INDEX,
  SHELL_OVERLAY_Z_INDEX,
} from 'constants/zIndex';

export const shellOverlayTheme = {
  token: {
    zIndexPopupBase: SHELL_OVERLAY_Z_INDEX,
  },
};

export const overlayDropdownStyles = {
  root: {
    zIndex: SHELL_OVERLAY_POPUP_Z_INDEX,
  },
} as ComponentProps<typeof Dropdown>['styles'];

export const overlayPopconfirmStyles = {
  root: {
    zIndex: SHELL_OVERLAY_POPUP_Z_INDEX,
  },
} as ComponentProps<typeof Popconfirm>['styles'];
